// TODO REPLACE THIS DIRECTIVE WITH THE NEW PERMISSION CHECKER DIRECTIVE

import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { IProfileEntity } from '@boma/supplier-portal/shared/entities';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[bomaHasPermissions]',
})
export class HasPermissionsDirective implements OnInit, OnDestroy {
  private currentEntity: IProfileEntity;
  private permissions: string[];
  private contains: any;
  private entitySub: Subscription;

  constructor(
    private store: Store,
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input()
  set bomaHasPermissions(val: string[]) {
    if (!val) return;
    this.permissions = val;
    //TODO hate doing it like this but could not figure how to pass a second var
    // Does the users permissions have or haveNot
    this.contains =
      val[0] === 'doesntHave' ? false : val[0] === 'have' ? true : null;
  }

  ngOnInit() {
    this.entitySub = this.store
      .select(getSelectedOrganizationInfo)
      .subscribe((org) => {
        this.currentEntity = org;
        this.updateView();
      });
  }

  ngOnDestroy() {
    this.entitySub?.unsubscribe();
  }

  private updateView() {
    this.viewContainer.clear();
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  private checkPermission() {
    if (!this.permissions) return false; // this is here in case for some reason the user is passing an empty has permissions array
    if (this.contains !== null) {
      this.permissions.shift(); // remove the true or false specified value
    }

    //console.log('check permissions');
    let hasPermission = false;

    if (this.currentEntity && this.currentEntity.permissions) {
      hasPermission = this.permissions.every(
        (x) => !!this.currentEntity.permissions.find((y) => x === y)
      );
    }
    if (this.contains === null) return hasPermission;
    if (!this.contains && !hasPermission) {
      return true;
    } else if (!this.contains && hasPermission) {
      return false;
    }

    return hasPermission;
  }
}
